export default {
    getPostLike(state) {
        return state.postLike;
    },
    getUserLike(state) {
        return state.userLike;
    }
}